function mapSpaceToVar(spacingMap, size) {
    return size ? `var(${spacingMap[size]})` : undefined;
}
/**
 * Generate axis related logical properties
 * @param {string} cssRuleName Name of CSS rule
 * @param {string} shorthandPropName Name of the prop that contains spacing shorthand list
 * @returns {function} a function accepting a props
 */
export function injectSpacing(cssRuleName, shorthandPropName = 'outerSpacing') {
    /**
     * @param {Object} props a set of props which must contain the theme, and a spacing shorthand list under the `shorthandPropName` key
     * @returns {string} css axis related logical properties
     */
    return (props) => {
        var _a;
        const [blockStart, inlineEnd, blockEnd, inlineStart] = (_a = props[shorthandPropName]) !== null && _a !== void 0 ? _a : [];
        const spacingMap = props.theme.responsive.spacing;
        const propertyEntries = [
            [`${cssRuleName}-block-start`, mapSpaceToVar(spacingMap, blockStart)],
            [`${cssRuleName}-inline-end`, mapSpaceToVar(spacingMap, inlineEnd)],
            [`${cssRuleName}-block-end`, mapSpaceToVar(spacingMap, blockEnd)],
            [`${cssRuleName}-inline-start`, mapSpaceToVar(spacingMap, inlineStart)],
        ];
        const rules = propertyEntries
            .filter(([, value]) => value)
            .map((entry) => `${entry.join(': ')};`);
        if (rules.length === 4) {
            return `${cssRuleName}: ${propertyEntries
                .map(([, value]) => value)
                .join(' ')};`;
        }
        return rules.join('\n');
    };
}
//# sourceMappingURL=injectSpacing.js.map